import { ILocationAreaMenuService } from '../../src/typings/ILocationAreaMenuService';
import { NavMenuItem } from '../../src/typings/NavMenuItem';
import { NavigationService } from '@caslink/device-client/ng-app/shared/services/navigation.service';
import * as _ from "lodash";
import { Injectable } from '@angular/core';
import { CommonLocationService } from '../location/CommonLocationService';

/**
 * Builds an "Area Menu" based on the available Location Areas
 */
@Injectable({
    providedIn: 'root'
})
export class LocationAreaMenuService implements ILocationAreaMenuService {
    public static $name: string = 'locationAreaMenuService';

    constructor(
        private commonLocationService: CommonLocationService,
        private navigationService: NavigationService
    ) {
    }

    public build(
        locationId: number,
        menuItem: NavMenuItem,
        areas: CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel[],
        state: string,
        refreshParent: () => void,
        isEnabledFunc?: (area: CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel) => boolean
    ) {
        if (!locationId) {
            return;
        }

        /**
         * Make sure that the object both exists & has been cleared from the last time this was ran
         * -- we don't want areas for one location appearing for another
         */
        menuItem.subItems = {
            items: {},
            menuContext: ''
        };

        areas.forEach(area => {
            var params = {
                areaId: area.id.toString(),
                areaName: area.tag,
                locationId: locationId.toString(),
                hardwareItemId: null
            };

            menuItem.subItems.items[area.id] = {
                alertCount: 0,
                areaId: area.id,
                confirmDelete: area.hasControls,
                deleteAction: (_: NavMenuItem) => {
                    return this.commonLocationService.deleteArea(area.id).then(() => refreshParent());
                },
                editAction: (updatedItem: NavMenuItem) => {
                    return this.commonLocationService.updateAreaName(locationId, area.id, updatedItem.text);
                },
                icon: area.icon,
                isEnabledFunc: _.isFunction(isEnabledFunc) ? isEnabledFunc.bind(null, area) : undefined,
                state: state,
                stateParams: params,
                text: area.tag,
            };
        });

        this.navigationService.setupMenuItem(locationId, menuItem);
    }
}
